import {Alert} from "react-bootstrap";
import React, { useState} from "react";

export default function useAlert(){
    const [error, setError] = useState({show:false, error:""});

    const showAlert = (error)=>{
        setError({show: true, error: error});
    }

    const hideAlert = ()=>setError({show: false, error: ""})

    const alert = ()=>{
        return <Alert className={"m-2"} show={error.show} variant={"danger"} >
            {error.error}
        </Alert>
    }

    return {
        showAlert,
        hideAlert,
        alert
    }
}


